import {
  Card,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';

import {
  useScenarioUnitMapQuery,
  useUnitListQuery,
} from '../../network/queries';
import { getCapacityString } from '../../utils/dataUtil';
import { Loader } from '../common';

function UnitTable({ scenarioId }) {
  const { t } = useTranslation();
  // TODO: investigate performance drawbacks of fetching unit list
  const { isLoading: isLoadingBaseUnits, data: baseUnits } = useUnitListQuery();
  const { isLoading: isLoadingUnitMap, data: unitMap } =
    useScenarioUnitMapQuery(scenarioId);

  return isLoadingBaseUnits || isLoadingUnitMap ? (
    <Loader />
  ) : (
    <Card variant="outlined">
      <TableContainer>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>{t('components.unitMap.name')}</TableCell>
              <TableCell align="right">
                {t('components.unitMap.capacity')}
              </TableCell>
              <TableCell align="right">
                {t('components.unitMap.mean')}
              </TableCell>
              <TableCell align="right">
                {t('components.unitMap.deviation')}
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {unitMap.map((unit) => {
              const baseUnit = baseUnits.find((i) => i.id === unit.id);
              return (
                <TableRow
                  key={unit.id}
                  sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                >
                  <TableCell component="th" scope="row">
                    {unit.name}
                  </TableCell>
                  <TableCell align="right">
                    {getCapacityString(baseUnit.capacity)} /{' '}
                    {getCapacityString(unit.capacity)}
                  </TableCell>
                  <TableCell align="right">
                    {baseUnit.stay_info?.mean_los || '-'} /{' '}
                    {unit.stay_info?.mean_los || '-'}
                  </TableCell>
                  <TableCell align="right">
                    {baseUnit.stay_info?.std_los || '-'} /{' '}
                    {unit.stay_info?.std_los || '-'}
                  </TableCell>
                </TableRow>
              );
            })}
          </TableBody>
        </Table>
      </TableContainer>
    </Card>
  );
}

export default UnitTable;
